import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BadgeCheck, Trash2 } from 'lucide-react';
import { formatDate, formatMoney } from '../format';

// The common case - all of it, now - is one tap; a prepayment is one number.
export default function PaymentPanel({ lead, onPay, onRemovePayment }) {
  const { t, i18n } = useTranslation('common');
  const [partial, setPartial] = useState('');

  const money = (value) => formatMoney(value, i18n.language);
  const due = lead.amount_due;

  const payPartial = () => {
    const amount = Number(partial);
    if (amount > 0) {
      setPartial('');
      onPay(amount);
    }
  };

  return (
    <div className="crm-payment">
      <div className="crm-payment-head">
        <span className={`crm-pay-badge crm-pay-${lead.payment_state}`}>
          {t(`crm.payment.${lead.payment_state}`)}
        </span>
        <span className="crm-payment-sum">
          {t('crm.payment.paidOf', {
            paid: money(lead.paid_total),
            total: lead.order_total === null ? '—' : money(lead.order_total),
          })}
        </span>
      </div>

      {due !== null && due > 0 && (
        <button type="button" className="crm-btn primary crm-pay-btn" onClick={() => onPay(due)}>
          <BadgeCheck size={17} />
          {t('crm.payment.markPaid', { amount: money(due) })}
        </button>
      )}

      {due !== null && due > 0 && (
        <div className="crm-payment-partial">
          <input
            className="crm-input"
            type="number"
            min="0"
            step="0.01"
            inputMode="decimal"
            value={partial}
            placeholder={t('crm.payment.partialHint')}
            aria-label={t('crm.payment.partial')}
            onChange={(event) => setPartial(event.target.value)}
            onKeyDown={(event) => event.key === 'Enter' && payPartial()}
          />
          <button type="button" className="crm-btn" disabled={!(Number(partial) > 0)} onClick={payPartial}>
            {t('crm.payment.addPartial')}
          </button>
        </div>
      )}

      {lead.payments.length > 0 && (
        <ul className="crm-payment-list">
          {lead.payments.map((payment) => (
            <li key={payment.id}>
              <strong>{money(payment.amount)} {t('crm.currency')}</strong>
              <span className="crm-cell-sub">
                {formatDate(payment.at)} · {payment.recorded_by_name}
              </span>
              <button
                type="button"
                className="crm-icon-btn"
                aria-label={t('crm.payment.remove')}
                onClick={() => onRemovePayment(payment.id)}
              >
                <Trash2 size={15} />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
